import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconMarker = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 8} height={props.height || 17} viewBox="0 0 8 17" fill="none">
      <svg width="8" height="17" viewBox="0 0 8 17" fill="none">
        <rect y="0.5" width="8" height="16" rx="4" fill={theme.colors.text.primary} />
      </svg>
    </IconBase>
  )
}
